/* eslint-disable prettier/prettier */
import TagName from "./column/TagName.vue"
import i18n from "@/i18n";
import { STATIC_IMG_PATH } from "@/views/zhiji/js/common/constants.js";

// 列配置
export const columns = [
  {
    colId: 'check',
    type: 'Checkbox',
    header: '',
    width: '37px',
  },
  {
    type: 'Text',
    colId: 'id',
    header: '标签ID',
  },
  {
    colId: 'name',
    header: '标签名称',
    component: TagName,
  },
  {
    type: 'Text',
    colId: 'param_condition',
    header: '参数条件',
  },
  {
    type: 'Status',
    colId: 'status',
    header: '状态',
    width: '100px',
  },
  {
    type: 'Text',
    colId: 'operator',
    header: '最新编辑',
  },
  {
    type: 'Operation',
    colId: 'operation',
    header: '操作',
  },
];

export const bottomButtons =  [
  {
      id: "del",
      text: i18n.t("zhiji.common.delete"),
      icon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px 0px",
      hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px -22px",
  },
  {
      id: "online",
      text: "启用",
      icon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -210px 0px",
      hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -210px -20px"
  },
  {
      id: "offline",
      text: "停用",
      icon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -230px 0px",
      hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -230px -20px"
  },
]

export const pageLength = 10;

export const pageLengthRank = [10, 20, 30, 100];

export const searchFilter = ({ params }) => [
  {
    props: {
      name: 'filterFields',
      inline: true,
      subItemLabelPosition: 'left',
    },
    uId: '0',
    cid: 'Form',
    events: [],
    children: [
      {
        props: {
          style: {
            width: '200px',
          },
          options: [
            {
                label: '所有状态',
                value: ''
            },
            {
                label: '已启用',
                value: '1'
            },
            {
                label: '未启用',
                value: '0'
            },
        ],
          name: 'status',
        },
        uId: '1',
        cid: 'Elselector',
        events: [],
        children: [],
      },
      {
        props: {
          style: {
            width: '220px',
          },
          multiple: true,
          collapseTags: true,
          filterable: true,
          clearable: true,
          placeholder: "选择相关参数",
          options: [
            ...params
        ],
          name: 'params',
        },
        uId: '2',
        cid: 'Elselector',
        events: [],
        children: [],
      },
      {
        props: {
          style: {
          },
          options: [
            {
              label: '按标签名称',
              value: 'name',
            },
          ],
          name: 'keyWordSearch',
        },
        uId: '3',
        cid: 'CombinedSearch',
        events: [],
        children: [],
      },
    ],
  },
];
